import React, { useEffect, useState, useContext } from 'react';
import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../../App';

const buttonStyle = {
  maxWidth: '180px',
  maxHeight: '35px',
  minWidth: '180px',
  minHeight: '35px',
  marginLeft: '4px',
};
const useStyles = makeStyles(
  createStyles({
    tableHeader: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      borderCollapse: `collapse`,
    },
    tableTd: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0px',
      textAlign: 'center',
    },
    colTime: {
      textAlign: 'center',
    },
  })
);

type Props = {
  onClickSaveButton: () => void;
  onClickCancelButton: () => void;
  onClickAllStartTimeSetButton: () => void;
  onChangeSortItem: (value: string) => void;
  onChangePLCDisp: (value: string) => void;
};

const CollectSettingFooter: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [sortItem, setSortItem] = React.useState('m');
  const [plcDisp, setPLCDisp] = React.useState('e');
  const { login } = useContext(AppContext);

  const changeSortItem = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSortItem(event.target.value);
    props.onChangeSortItem(event.target.value);
  };
  const changePLCDispItem = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPLCDisp(event.target.value);
    props.onChangePLCDisp(event.target.value);
  };

  return (
    <Grid
      container
      justify="flex-start"
      spacing={1}
      direction="row"
      alignItems="center"
      style={{ width: 'calc(100vw - 12px)' }}
    >
      {login.IsIoT ? (
      <>
        <Grid item xs={2}>
        <Button
          style={buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) => props.onClickSaveButton()}
        >
          {t('CollectSettingFooter.保存', '保存')}
        </Button>
        </Grid>
        <Grid item xs={2}>
          <Button
            style={buttonStyle}
            variant="contained"
            color="primary"
            disableElevation
            onClick={(e) => props.onClickCancelButton()}
          >
            {t('CollectSettingFooter.中止', '中止')}
          </Button>
        </Grid>
      </>) : (
      <>
        <Grid item xs={2}>
        <Button
          style={buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) => props.onClickSaveButton()}
        >
          {t('CollectSettingFooter.保存', '保存')}
        </Button>
        </Grid>
        <Grid item xs={2}>
          <Button
            style={buttonStyle}
            variant="contained"
            color="primary"
            disableElevation
            onClick={(e) => props.onClickCancelButton()}
          >
            {t('CollectSettingFooter.中止', '中止')}
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Table style={{ marginBottom: '4px' }}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableTd}>{t('CollectSettingFooter.並び順', '並び順')}</TableCell>
                <TableCell className={classes.tableTd}>
                  <Radio
                    checked={sortItem === 'm'}
                    onChange={changeSortItem}
                    value="m"
                    inputProps={{ 'aria-label': 'M' }}
                  />
                  {t('CollectSettingFooter.機器', '機器')}
                </TableCell>
                <TableCell className={classes.tableTd}>
                  <Radio
                    checked={sortItem === 'p'}
                    onChange={changeSortItem}
                    value="p"
                    inputProps={{ 'aria-label': 'P' }}
                  />
                  PLC
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
        <Grid item xs={3}>
          <Table style={{ marginBottom: '4px' }}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableTd}>{t('CollectSettingFooter.PLC情報', 'PLC情報')}</TableCell>
                <TableCell className={classes.tableTd}>
                  <Radio
                    checked={plcDisp === 'e'}
                    onChange={changePLCDispItem}
                    value="e"
                    inputProps={{ 'aria-label': 'E' }}
                  />
                  {t('CollectSettingFooter.非表示', '非表示')}
                </TableCell>
                <TableCell className={classes.tableTd}>
                  <Radio
                    checked={plcDisp === 'd'}
                    onChange={changePLCDispItem}
                    value="d"
                    inputProps={{ 'aria-label': 'D' }}
                  />
                  {t('CollectSettingFooter.表示', '表示')}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </>) }
    </Grid>
  );
};

export default CollectSettingFooter;
